const $ = jQuery.noConflict();

export default class Header {
	constructor() {
		this.$links = $('.js-main-menu a');
		this.activeSubMenuClass = 'js-active-submenu';
		this.isClosingMenu = false;
		this.handleMenuToggle();	
		this.handleSubMenuToggle();	
		this.handleScrolling();
	}

	handleMenuToggle() {
		const Header = this, 
			$body = $('body'),
			$closingElements = $('.js-body-overlay, .nav__submenu a'),
			$toggleButton = $('.js-nav-toggle'),
			activeClass = 'js-active-nav';

		const closeMenu = st => {
			$body.removeClass(activeClass);
			// prevent header hide
			Header.isClosingMenu = true;
			$body.scrollTop(st);

			// re-enable header hide
			setTimeout(() => {
				Header.isClosingMenu = false;
			}, 100);
		}

		let st = 0;

		$toggleButton.click(() => {
			if ($body.hasClass(activeClass)) {
				closeMenu(st);

			} else {
				st = $body.scrollTop();
				$body.css('top', `-${st}px`);
				$body.addClass(activeClass);
			}	
		});

		$closingElements.click(() => {
			closeMenu(st);
		});
	}

	handleSubMenuToggle() {
		const _this = this;

		_this.$links.click(function(e) {
			const $link = $(this),
				$submenu = $link.next('.js-sub-menu'),
				isActiveThis = $link.hasClass(_this.activeSubMenuClass);

			if ($submenu.length) {
				e.preventDefault();

				_this.$links.removeClass(_this.activeSubMenuClass);

				if (!isActiveThis) {
					$link.addClass(_this.activeSubMenuClass);
				}
				
			}
		});

		$('.nav__submenu a').click(() => {
			console.log('hello');
			_this.$links.removeClass(_this.activeSubMenuClass);
		});
	}

	handleScrolling() {
		const _this = this, 
			$header = $('#js-header'),
			hiddenClass = 'js-hidden-header',
			scrollingClass = 'js-scrolling-header';

		let lastSt = 0,
			isHiddenHeader = false;

		$(document).scroll(function() {
			let st = $(this).scrollTop();

			// hide sub menus
			_this.$links.removeClass(_this.activeSubMenuClass);

			// down scroll
			if (st > lastSt) {
				// header slides up - unless the menu was just closed
				if (st > 100 && !_this.isClosingMenu) {
					$header.addClass(hiddenClass);
					isHiddenHeader = true;	
				} 

			// up scroll
			} else {
				$header.removeClass(hiddenClass);
				isHiddenHeader = false;
			}

			// box-shadow 
			if (st > 0 && !isHiddenHeader) {
				$header.addClass(scrollingClass);
			} else {
				$header.removeClass(scrollingClass);
			}

			lastSt = st;
		});
	}
}



// WEBPACK FOOTER //
// ./assets/js/src/components/Header.js